/* Chula — the request panel on a commissioned piece
 *
 * Markup and copy: snippets/chula-request-panel.liquid
 * Styles:          assets/chula-panels.css (the crqm block)
 *
 * What this file is responsible for, and nothing else:
 *   - opening and closing the panel,
 *   - swapping the photograph when a colour is chosen,
 *   - keeping the pill's label current with the selection,
 *   - the measurements disclosure,
 *   - re-opening the panel on the reload that follows a successful post.
 *
 * Everything else works without it. Size and colour are real radios, so the
 * chosen values post with no JavaScript, and the opener is an anchor to the
 * Made to Measure page, so a failure here still reaches the atelier.
 */

(function () {
  'use strict';

  if (window.chulaRequestPanelBound) return;
  window.chulaRequestPanelBound = true;

  var OPEN_MS = 700;

  function panelFor(el) {
    return el ? el.closest('[data-crq-panel]') : null;
  }

  function firstPanel() {
    return document.querySelector('[data-crq-panel]');
  }

  /* ── The plate on the photograph ───────────────────────────────────────
     It names what is selected, so it has to READ the radios rather than
     remember them: the panel can be reopened, and a browser can restore a
     radio state this script never saw chosen. */
  function syncPlate(panel) {
    var plate = panel.querySelector('[data-crq-plate]');
    if (!plate) return;

    var sizeOut = plate.querySelector('[data-crq-plate-size]');
    var colourOut = plate.querySelector('[data-crq-plate-colour]');
    var size = panel.querySelector('[data-crq-size]:checked');
    var colour = panel.querySelector('[data-crq-colour]:checked');

    if (sizeOut) sizeOut.textContent = size ? size.value : '';
    if (colourOut) {
      colourOut.textContent = colour ? colour.value : '';
      colourOut.hidden = !colour;
    }

    /* Nothing selected and nothing to select: no plate. A caption with no
       caption in it is worse than bare artwork. */
    plate.hidden = !size && !colour;
  }

  /* The photograph follows the colour. `data-crq-colour-img` is written per
     value in Liquid from that variant's own featured image, so an empty one
     means the merchant has not given that colour a photograph — in which case
     the hero stays, rather than blanking the column. */
  function syncImage(panel, input) {
    var img = panel.querySelector('[data-crq-img]');
    if (!img || !input) return;
    var src = input.getAttribute('data-crq-colour-img');
    if (!src || src === img.getAttribute('src')) return;

    /* Preload before swapping, or the column flashes empty on a slow
       connection. On failure the old photograph simply stays. */
    var next = new Image();
    next.onload = function () {
      img.setAttribute('src', src);
      img.removeAttribute('srcset');
    };
    next.src = src;
  }

  function open(panel, opener) {
    if (!panel) return;
    if (panel.getAttribute('data-open') === '1') return;

    panel.hidden = false;
    panel.setAttribute('data-open', '1');

    /* The shared lock, and nothing of our own on top of it — it owns the
       scroll position, the fixed branch on touch, the scrollbar padding and
       the restore. A second inline `top` here is the bug that stranded
       Friends of the House. It also hides the header, which matters: a fixed
       header stays sharp through a backdrop-filter and would sit on top of
       the blur. */
    if (window.chulaPageLock) window.chulaPageLock.lock();

    /* Never gate the reveal on requestAnimationFrame — it does not fire in a
       hidden or throttled tab, which would leave the page locked behind an
       invisible dialog. A forced reflow is synchronous and the transition
       still runs. */
    void panel.offsetHeight;
    panel.classList.add('is-in');

    syncPlate(panel);

    if (window.chulaFocusTrap) {
      window.chulaFocusTrap.activate(panel, opener || null);
    } else {
      var x = panel.querySelector('.crqm__x');
      if (x) { try { x.focus({ preventScroll: true }); } catch (e) {} }
    }
  }

  function close(panel) {
    if (!panel || panel.getAttribute('data-open') !== '1') return;
    panel.removeAttribute('data-open');
    panel.classList.remove('is-in');

    if (window.chulaFocusTrap) window.chulaFocusTrap.release(panel);
    if (window.chulaPageLock) window.chulaPageLock.unlock();

    /* transitionend is not trusted — it never fires in a hidden tab — so the
       panel is taken out of the flow on a timer instead. */
    window.setTimeout(function () {
      if (panel.getAttribute('data-open') === '1') return;
      panel.hidden = true;
    }, OPEN_MS);
  }

  /* Delegated throughout: the opener renders twice (product-info renders
     twice per product page) and both copies open the one panel. */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest ? e.target.closest('[data-crq-open]') : null;
    if (opener) {
      var panel = firstPanel();
      if (!panel) return;            /* no panel on this page: let the href go */
      e.preventDefault();
      open(panel, opener);
      return;
    }

    var closer = e.target.closest ? e.target.closest('[data-crq-close]') : null;
    if (closer) {
      e.preventDefault();
      close(panelFor(closer));
      return;
    }

    var more = e.target.closest ? e.target.closest('[data-crq-more]') : null;
    if (more) {
      var host = panelFor(more);
      var block = host && host.querySelector('[data-crq-measure]');
      if (!block) return;
      var willOpen = block.hidden;
      block.hidden = !willOpen;
      more.setAttribute('aria-expanded', String(willOpen));
      if (willOpen) {
        var first = block.querySelector('input');
        if (first) { try { first.focus({ preventScroll: true }); } catch (err) {} }
      }
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;

    if (t.matches('[data-crq-colour]')) {
      var panel = panelFor(t);
      if (!panel) return;
      syncImage(panel, t);
      syncPlate(panel);
      return;
    }

    if (t.matches('[data-crq-size]')) {
      var p2 = panelFor(t);
      if (p2) syncPlate(p2);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var open = document.querySelector('[data-crq-panel][data-open="1"]');
    if (open) close(open);
  });

  /* Shopify answers a contact post with a reload carrying
     ?contact_posted=true, so the confirmation arrives on a fresh page with the
     dialog closed. Re-open it, or the thank-you is inside something nobody
     opened. Left on the URL deliberately untouched: replaceState would make a
     refresh re-show a confirmation for a request already sent. */
  document.addEventListener('DOMContentLoaded', function () {
    var panel = firstPanel();
    if (!panel) return;

    syncPlate(panel);

    if (window.location.search.indexOf('contact_posted=true') === -1) return;
    if (!panel.querySelector('[data-crq-sent]')) return;
    open(panel, null);
  });
})();
